"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Trigger;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _helpers = require("@paprika/helpers");

var _Label = _interopRequireDefault(require("../Label"));

var _handleKeyboardKeys = require("../../helpers/handleKeyboardKeys");

var _useListBox3 = _interopRequireDefault(require("../../useListBox"));

var _OnChangeProvider = require("../../store/OnChangeProvider");

var _PropsProvider = require("../../store/PropsProvider");

var _invokeOnChange = _interopRequireWildcard(require("../../helpers/invokeOnChange"));

var sc = _interopRequireWildcard(require("./Trigger.styles"));

var _DOMAttributes = require("../../helpers/DOMAttributes");

var _excluded = ["children", "clearIcon", "hasClearButton", "hasImplicitAll", "isHidden", "label", "onClickClear", "onClickFooterAccept"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Trigger(props) {
  var I18n = (0, _useI18n["default"])();

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var providedProps = _react["default"].useContext(_PropsProvider.PropsContext);

  var children = props.children,
      clearIcon = props.clearIcon,
      hasClearButton = props.hasClearButton,
      hasImplicitAll = props.hasImplicitAll,
      isHidden = props.isHidden,
      label = props.label,
      onClickClear = props.onClickClear,
      onClickFooterAccept = props.onClickFooterAccept,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var a11yProps = providedProps.a11yProps,
      hasError = providedProps.hasError,
      idListBox = providedProps.idListBox,
      isDisabled = providedProps.isDisabled,
      isInline = providedProps.isInline,
      isReadOnly = providedProps.isReadOnly,
      refLabel = providedProps.refLabel,
      size = providedProps.size;
  var activeOption = state.activeOption,
      hasFooter = state.hasFooter,
      isOpen = state.isOpen,
      isMulti = state.isMulti,
      onChange = state.onChange,
      options = state.options,
      refTrigger = state.refTrigger,
      refTriggerContainer = state.refTriggerContainer,
      selectedOptions = state.selectedOptions;
  var placeholder = props.placeholder || providedProps.placeholder;

  var idFormLabel = _react["default"].useRef();

  _react["default"].useEffect(function () {
    var $label = refLabel && refLabel.current;
    if (!$label) return;
    var possibleId = $label.getAttribute("id");

    if (possibleId) {
      idFormLabel.current = possibleId;
    } else {
      var newId = "".concat(idListBox, "__form-label");
      $label.setAttribute("id", newId);
      idFormLabel.current = newId;
    }

    function handleClickLabel() {
      refTrigger.current.focus();
    }

    $label.addEventListener("click", handleClickLabel);
    return function () {
      $label.removeEventListener("click", handleClickLabel);
    };
  }, [refLabel, refTrigger, idListBox]);

  _react["default"].useEffect(function () {
    var _getActiveElement, _getActiveElement$dat;

    if (isOpen && ((_getActiveElement = (0, _helpers.getActiveElement)()) === null || _getActiveElement === void 0 ? void 0 : (_getActiveElement$dat = _getActiveElement.dataset) === null || _getActiveElement$dat === void 0 ? void 0 : _getActiveElement$dat.pkaAnchor) === "list-box-trigger" && state.selectedOptions.length && !state.isMulti) {
      var id = setTimeout(function () {
        document.getElementById(state.options[state.selectedOptions[0]].id).focus();
      }, 350); // popover animation :/

      return function () {
        clearTimeout(id);
      };
    }
  }, [isOpen, state.options, state.selectedOptions, state.isMulti]);

  var handleClick = function handleClick() {
    if (isOpen) {
      dispatch({
        type: _useListBox3["default"].types.closePopover
      });
      return;
    }

    dispatch({
      type: _useListBox3["default"].types.openPopover
    });
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault();
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === "Escape") {
      dispatch({
        type: _useListBox3["default"].types.closePopover
      });
      return;
    }

    if ([" ", "Enter", "ArrowDown"].includes(event.key)) {
      dispatch({
        type: _useListBox3["default"].types.openPopover
      });
    }
  };

  var handleClickClear = function handleClickClear() {
    if (isDisabled) {
      return;
    }

    if (onClickClear) {
      onClickClear(state, dispatch);
      return;
    }

    if (hasFooter) {
      dispatch({
        type: _useListBox3["default"].types.clear,
        payload: {
          isOpen: false,
          onChangeFn: (0, _invokeOnChange["default"])(onClickFooterAccept, "list-box:footer:clear")
        }
      });
      return;
    }

    dispatch({
      type: _useListBox3["default"].types.clear,
      payload: {
        isOpen: false,
        onChangeFn: (0, _invokeOnChange["default"])(onChange, "list-box:clear")
      }
    });
  };

  var hasRenderTrigger = typeof children === "function";
  var shouldHideClearButton = !hasClearButton || hasRenderTrigger || isReadOnly || hasFooter && isOpen || selectedOptions.length === 0;
  var shouldHideCaret = hasRenderTrigger || isInline;

  function renderLabel() {
    return isInline || isReadOnly ? /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      activeOption: options[activeOption],
      hasImplicitAll: hasImplicitAll,
      id: "".concat(idListBox, "__label"),
      isDisabled: isDisabled,
      isMulti: isMulti,
      label: label,
      options: options,
      placeholder: placeholder,
      selectedOptions: selectedOptions
    }) : /*#__PURE__*/_react["default"].createElement(_rawButton["default"], (0, _extends2["default"])({}, (0, _DOMAttributes.getDOMAttributesForListBoxButton)({
      idListBox: idListBox,
      idFormLabel: idFormLabel.current,
      isOpen: isOpen
    }), a11yProps, {
      "data-pka-anchor": "list-box-trigger",
      isDisabled: isDisabled,
      onClick: handleClick,
      onKeyUp: handleKeyUp,
      onKeyDown: handleKeyDown,
      ref: refTrigger
    }), /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      activeOption: options[activeOption],
      hasImplicitAll: hasImplicitAll,
      id: "".concat(idListBox, "__label"),
      isDisabled: isDisabled,
      isMulti: isMulti,
      label: label,
      options: options,
      placeholder: placeholder,
      selectedOptions: selectedOptions
    }));
  }

  function renderCaret() {
    return isOpen ? /*#__PURE__*/_react["default"].createElement(sc.UpIcon, {
      isDisabled: isDisabled || isReadOnly
    }) : /*#__PURE__*/_react["default"].createElement(sc.DownIcon, {
      isDisabled: isDisabled || isReadOnly
    });
  }

  function renderClearButton() {
    return /*#__PURE__*/_react["default"].createElement(sc.ClearButton, {
      a11yText: I18n.t("listBox.trigger.clear_selection"),
      "data-pka-anchor": "clear-button",
      isDisabled: isDisabled,
      isSemantic: false,
      kind: _button["default"].types.kind.MINOR,
      onClick: handleClickClear,
      shouldHideCaret: shouldHideCaret,
      size: size
    }, clearIcon || /*#__PURE__*/_react["default"].createElement(_StyledScClearIcon, {
      isDisabled: isDisabled,
      $_css: sc.iconStyles
    }));
  }

  var renderChildrenProps = _react["default"].useMemo(function () {
    if (hasRenderTrigger) {
      var attributes = {
        dispatch: dispatch,
        handleKeyDown: (0, _handleKeyboardKeys.handleKeyDownKeyboardKeys)({
          providedProps: providedProps,
          state: state,
          dispatch: dispatch,
          onChangeContext: onChangeContext
        }),
        handleKeyUp: (0, _handleKeyboardKeys.handleKeyUpKeyboardKeys)({
          providedProps: providedProps,
          state: state,
          dispatch: dispatch,
          onChangeContext: onChangeContext
        }),
        isOpen: isOpen,
        onChangeContext: onChangeContext,
        propsForTrigger: function propsForTrigger() {
          return (0, _DOMAttributes.getDOMAttributesForListBoxButton)({
            idListBox: idListBox,
            idFormLabel: idFormLabel.current,
            isOpen: isOpen
          });
        },
        refTrigger: refTrigger,
        types: (0, _invokeOnChange.sanitizeActionTypes)(_useListBox3["default"].types)
      };

      if (isMulti) {
        var _getSelectedOptionsMu = (0, _invokeOnChange.getSelectedOptionsMulti)(state),
            _getSelectedOptionsMu2 = (0, _slicedToArray2["default"])(_getSelectedOptionsMu, 3),
            _selected = _getSelectedOptionsMu2[0],
            _options2 = _getSelectedOptionsMu2[1],
            current = _getSelectedOptionsMu2[2];

        return children(_selected, _options2, current, attributes);
      }

      var _getSelectedOptionSin = (0, _invokeOnChange.getSelectedOptionSingle)(state),
          _getSelectedOptionSin2 = (0, _slicedToArray2["default"])(_getSelectedOptionSin, 2),
          selected = _getSelectedOptionSin2[0],
          _options = _getSelectedOptionSin2[1];

      return children(selected, _options, attributes);
    }
  }, [children, dispatch, hasRenderTrigger, idListBox, isMulti, isOpen, onChangeContext, refTrigger, state]);

  if (isHidden && isInline) {
    return /*#__PURE__*/_react["default"].createElement(sc.ListBoxTrigger, {
      "data-pka-anchor": "list-box-trigger",
      isHidden: true
    });
  }

  return /*#__PURE__*/_react["default"].createElement(sc.ListBoxTrigger, (0, _extends2["default"])({
    hasError: hasError,
    isDisabled: isDisabled,
    isInline: isInline,
    isReadOnly: isReadOnly,
    ref: refTriggerContainer,
    size: size
  }, moreProps), hasRenderTrigger ? renderChildrenProps : renderLabel(), shouldHideClearButton ? null : renderClearButton(), shouldHideCaret ? null : renderCaret());
}

Trigger.displayName = "ListBox.Trigger";
Trigger.propTypes = {
  /** Custom clear icon */
  clearIcon: _propTypes["default"].node,

  /** Body content of the trigger. */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /** If true it adds a clear button */
  hasClearButton: _propTypes["default"].bool,

  /** Has implicit "All items selected" value when no item is selected */
  hasImplicitAll: _propTypes["default"].bool,

  /** Override the label with a custom one. */
  label: _propTypes["default"].string,

  /** Callback to be executed when the clear button is clicked or activated by keyboard. */
  onClickClear: _propTypes["default"].func,

  /** Callback to be executed when the accept button is clicked or activated by keyboard. */
  onClickFooterAccept: _propTypes["default"].func,

  /** Sets a placeholder for the trigger */
  placeholder: _propTypes["default"].string,

  /** If true the trigger will be hidden */
  isHidden: _propTypes["default"].bool
};
Trigger.defaultProps = {
  clearIcon: null,
  children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  hasClearButton: true,
  hasImplicitAll: false,
  label: null,
  onClickClear: null,
  onClickFooterAccept: null,
  placeholder: null,
  isHidden: false
};

var _StyledScClearIcon = (0, _styledComponents["default"])(sc.ClearIcon).withConfig({
  displayName: "Trigger___StyledScClearIcon",
  componentId: "sc-1kdta3o-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Trigger.js.map